$(document).on('click', '.qty-btn', function (e) {
     console.log("Qty button clicked");
        let input = this.parentElement.querySelector("input");
            let currentValue = parseInt(input.value);
            let key = this.getAttribute("data-key");

            if (this.classList.contains("plus")) {
                input.value = currentValue + 1;
            } else if (this.classList.contains("minus") && currentValue > 1) {
                input.value = currentValue - 1;
            }
         
          let lineKey = input.getAttribute("data-line-key");
          let sectionsToBundle = "";
          const responseqty = fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: input.value,
              sections: sectionsToBundle
            })
          });

          setTimeout(function() { 
            console.log("Cart refreshed");
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }, 800);
});

/*document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".qty-btn").forEach(button => {
        button.addEventListener("click", function () {
            let input = this.parentElement.querySelector("input");
            let currentValue = parseInt(input.value);
            let key = this.getAttribute("data-key");

            if (this.classList.contains("plus")) {
                input.value = currentValue + 1;
            } else if (this.classList.contains("minus") && currentValue > 1) {
                input.value = currentValue - 1;
            }
         
          let lineKey = input.getAttribute("data-line-key");
          let sectionsToBundle = "";
          const responseqty = fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: input.value,
              sections: sectionsToBundle
            })
          });

          setTimeout(function() { 
            console.log("Cart refreshed");
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }, 1000);
           
        });
    });
});*/